import {Errors} from '../types';

export const getDisplayErrorMsg = (errorString = ''): string => {
  const err = errorString.toLowerCase();
  if (err.includes('network')) {
    return Errors.NETWORK;
  }
  if (['400', '401', '403'].some(code => err.includes(code))) {
    return Errors.INVALID;
  }
  if (['429', '500', '503'].some(code => err.includes(code))) {
    return Errors.DEFAULT;
  }
  return errorString || Errors.DEFAULT;
};
